<template>
    <b-container>
        <b-row class="homeDiv" id="home">
            <b-col sm="12" md="7" class="homeDivFirst">
                <h1 v-html="$t('homeTitle')"></h1>
                <!-- <TypingLetters /> -->
                <div class="resCenter">
                  <DiscussBtn />
                </div>
            </b-col>
            <b-col sm="12" md="5">
                <video autoplay muted loop playsinline id="vid" ref="vid" :width="videoWidth">

                <source src="@/assets/imagesHome/homeVideo.mp4"
                      type="video/mp4">

                Sorry, your browser doesn't support embedded videos.
                </video>            
          </b-col>
        </b-row>
        <b-row>
            <b-col class="homeFooter" cols="12">
            <a href="#Steps" v-smooth-scroll="{offset: -80}">
                <img src="@/assets/imagesHome/seeItYouself.png" alt="Welcome to the IT Jonction website">
            </a>
            <div id="triggerStep0"></div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import DiscussBtn from '@/components/DiscussBtn.vue'
// import TypingLetters from '@/components/home/TypingLetters.vue'

export default {
    name: "Landing",
    components: {
        DiscussBtn,
        // TypingLetters
    },
    computed: {
      videoWidth: function () {
        if(window.innerWidth<768) {
          return '100%'
        } else if(window.innerWidth<900) {
          return '300'
        } else if(window.innerWidth<1000) {
          return '350'
        } else if(window.innerWidth<1200) {
          return '400'
        } else {
          return '500'
        }
      }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/landing.scss';

.homebg{
    background: url('../../assets/bg_Dots.png') 100%;
}
</style>